__turbopack_context__.v({
  "deadline": "cart-campaign-countdown-module__-_p4Pa__deadline",
  "label": "cart-campaign-countdown-module__-_p4Pa__label",
  "root": "cart-campaign-countdown-module__-_p4Pa__root",
  "timer": "cart-campaign-countdown-module__-_p4Pa__timer",
});
